import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LayoutFacade } from '@ebeihilfe/web-logic';
import { wait } from '@ebeihilfe/core';

@Component({
    selector: 'portal-page',
    templateUrl: './portal-page.component.html',
    styleUrls: ['./portal-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PortalPagComponent implements OnInit {
  @Input() public design: 'box' | 'col2' | 'none';
  @Input() public showBackground = false;

  constructor(private layoutFacade: LayoutFacade) {}

  public async ngOnInit(): Promise<void> {
    await wait(0);

    this.layoutFacade.layoutChanged({ showBackgroundImage: this.showBackground });
  }
}
